module.exports = __webpack_public_path__ + "img/create-1.cdbef947.png";